import { LinkableItem, LinkableItemLifecycleStates } from '@skinsoft/entity-data-store';
import { get } from 'lodash';

import { Movement, MovementLifecycleStates, MovementTypes } from './movement-data-store';

export const id = (movement: Movement) => get(movement, 'id');
export const author = (movement: Movement) => get(movement, 'managementData.creatorUser');

export const inventaryNumber = (movement: Movement) => get(movement, 'movementSchema.identificationNumber.value')

export const incrementalTitle = (movement: Movement) =>
    get(movement, 'movementSchema.identificationNumber');

export const endDate = (movement: Movement) => {
    const serializedDate =
        get(movement, 'movementSchema.effectiveDates.endDate.startInterval.date', null) || null;
    return serializedDate ? new Date(serializedDate) : undefined;
};

export const startDate = (movement: Movement) => {
    const serializedDate =
        get(movement, 'movementSchema.effectiveDates.startDate.startInterval.date', null) || null;
    return serializedDate ? new Date(serializedDate) : undefined;
};

export const indexTitle = (movement: Movement) => get(movement, 'indexTitle')

export const title = (movement: Movement) =>
    get(movement, 'movementSchema.title') || get(movement, 'title');

export const availableLifecycleStates = (movement: Movement): MovementLifecycleStates[] =>
    get(movement, 'workflowSchema.currentState.availableLifecycleStates', []);

export const state = (movement: Movement): MovementLifecycleStates =>
    get(movement, 'workflowSchema.currentState.name', null);

export const linkableItems = (movement: Movement): LinkableItem[] =>
    get(movement, 'workflowSchema.linkableItems', []) || [];

export const motive = (movement: Movement) => get(movement, 'movementSchema.movementMotif', null);

export const movementType = (movement: Movement) => get(movement, 'movementType') as MovementTypes;

export const associatedTasks = (movement: Movement) =>
    get(movement, 'movementSchema.associatedTasks', []) as string[];

export const canLinkableItemTransitionTo = (
    movement: Movement,
    linkableItemId: LinkableItem['linkableItem'],
    targetLinkableItemState: LinkableItemLifecycleStates,
) => {
    const linkableItem = linkableItems(movement).find(
        i => i.linkableItem === linkableItemId,
    ) as LinkableItem;

    if (state(movement) !== MovementLifecycleStates.IN_PROGRESS) {
        return false;
    }

    return linkableItem.state.availableLifecycleStates.indexOf(targetLinkableItemState) !== -1;
};

export const linkableItemState = (
    movement: Movement,
    linkableItemId: LinkableItem['linkableItem'],
) => {
    const linkableItem = linkableItems(movement).find(
        l => l.linkableItem === linkableItemId,
    ) as LinkableItem;

    return linkableItem.state.name;
};

export const linkableItemArrivalLocation = (
    movement: Movement,
    linkableItemId: LinkableItem['linkableItem'],
) => {
    const linkableItem = linkableItems(movement).find(
        l => l.linkableItem === linkableItemId,
    ) as LinkableItem;

    return linkableItem.arrivalLocation;
};
